import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJTextToImageRightPresetItem.module.less';
import ProIcon from '../../../../assets/svg/pro-tag.svg?react';
import FastIcon from '../../../../assets/svg/fast-tag.svg?react';
import UltraIcon from '../../../../assets/svg/ultra-tag.svg?react';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import classNames from 'classnames';

const FJTextToImageRightPresetItem = ({ presetInfo, onClickUsePrompt }) => {
    const videoRef = useRef(null);
    const [isPlayingVideo, setIsPlayingVideo] = useState(false);

    const _onMouseOver = () => {
        setIsPlayingVideo(true);
    };
    const _onMouseLeave = () => {
        setIsPlayingVideo(false);
    };

    return (
        <div className={styles.preset_item_box} onMouseEnter={_onMouseOver} onMouseLeave={_onMouseLeave}>
            <img
                src={presetInfo.imageUrl}
                className={classNames(styles.big_img, !presetInfo.videoUrl ? styles.noVideo : '')}
                alt={presetInfo.prompt}
            />

            {presetInfo.videoUrl && isPlayingVideo && (
                <video src={presetInfo.videoUrl} ref={videoRef} loop autoPlay muted={true} />
            )}

            <div className={styles.item_prompt_box}>
                <div className={styles.prompt}>
                    {presetInfo.smallImageUrl && <img className={styles.img} src={presetInfo.smallImageUrl} alt='' />}
                    <div className={styles.item_prompt_span}>{presetInfo.prompt}</div>
                </div>

                <div className={styles.item_prompt_btn_box}>
                    {presetInfo.model_type && (
                        <div className={styles.item_prompt_tag_item}>
                            {presetInfo.model_type === 'pro' && (
                                <>
                                    <ProIcon />
                                    <span>{FJLocalStore._('pro')}</span>
                                </>
                            )}
                            {presetInfo.model_type === 'fast' && (
                                <>
                                    <FastIcon />
                                    <span>{FJLocalStore._('fast')}</span>
                                </>
                            )}
                            {presetInfo.model_type === 'ultra' && (
                                <>
                                    <UltraIcon />
                                    <span>{FJLocalStore._('ultra')}</span>
                                </>
                            )}
                        </div>
                    )}
                    <div
                        className={styles.use_prompt_btn}
                        onClick={() => onClickUsePrompt && onClickUsePrompt(presetInfo)}
                    >
                        {FJLocalStore._('use-prompt')}
                    </div>
                </div>
            </div>
        </div>
    );
};

FJTextToImageRightPresetItem.propTypes = {
    presetInfo: PropTypes.object,
    onClickUsePrompt: PropTypes.func,
};

export default FJTextToImageRightPresetItem;
